export * from "./weeks-target.component";
